import { api } from '../main-api/apiClient';

export const SystemAdminConfigAPI = {
  // Get all configurations with optional filtering
  getAllConfigs: async (filters = {}) => {
    const queryString = new URLSearchParams(filters).toString();
    const url = queryString ? `/system-admin/config/?${queryString}` : `/system-admin/config/`;
    const response = await api.get(url);
    return response.data;
  },

  // Create new configuration
  createConfig: async (configData) => {
    const response = await api.post('/system-admin/config/', configData);
    return response.data;
  },

  // Update existing configuration
  updateConfig: async (configId, updateData) => {
    const response = await api.put(`/system-admin/config/${configId}`, updateData);
    return response.data;
  },

  // Delete configuration
  deleteConfig: async (configId) => {
    const response = await api.delete(`/system-admin/config/${configId}`);
    return response.data;
  },

  // Get modules configuration
  getModules: async () => {
    const response = await api.get('/system-admin/config/modules');
    return response.data;
  },

  // Update modules configuration
  updateModules: async (modulesData) => {
    const response = await api.put('/system-admin/config/modules', modulesData);
    return response.data;
  },

  // Get categories with optional filtering
  getCategories: async (filters = {}) => {
    const queryString = new URLSearchParams(filters).toString();
    const url = `/system-admin/config/categories${queryString ? `?${queryString}` : ''}`;
    const response = await api.get(url);
    return response.data;
  },

  // Create new category
  createCategory: async (categoryData) => {
    const response = await api.post('/system-admin/config/categories', categoryData);
    return response.data;
  },

  // Update category
  updateCategory: async (categoryId, updateData) => {
    const response = await api.put(`/system-admin/config/categories/${categoryId}`, updateData);
    return response.data;
  },

  // Delete category
  deleteCategory: async (categoryId) => {
    const response = await api.delete(`/system-admin/config/categories/${categoryId}`);
    return response.data;
  },

  // Get subcategories with optional filtering
  getSubcategories: async (filters = {}) => {
    const queryString = new URLSearchParams(filters).toString();
    const url = `/system-admin/config/subcategories${queryString ? `?${queryString}` : ''}`;
    const response = await api.get(url);
    return response.data;
  },

  // Create new subcategory
  createSubcategory: async (subcategoryData) => {
    const response = await api.post('/system-admin/config/subcategories', subcategoryData);
    return response.data;
  },

  // Update subcategory
  updateSubcategory: async (subcategoryId, updateData) => {
    const response = await api.put(`/system-admin/config/subcategories/${subcategoryId}`, updateData);
    return response.data;
  },

  // Delete subcategory
  deleteSubcategory: async (subcategoryId) => {
    const response = await api.delete(`/system-admin/config/subcategories/${subcategoryId}`);
    return response.data;
  }
};